import {BaseModel} from "./base-model";

export class Skill extends BaseModel {

  protected static self = Skill;

  companyId: number;
  name: string;
  color: string;
  validityInDays: number;

  public validate(): boolean {
    return true;
  }
}

export class SkillLevel extends BaseModel {

  protected static self = SkillLevel;

  companyId: number;
  name: string;
  isExpert: boolean;
  isTutor: boolean;

  public validate(): boolean {
    return true;
  }
}

export class UserSkillBind extends BaseModel {

  protected static self = UserSkillBind;

  skill: Skill;
  skillLevel: SkillLevel;
  startAt: number;
  expiringAt: number;

  constructor() {
    super();
    this.skill = new Skill();
    this.skillLevel = new SkillLevel();
  }

  public validate(): boolean {
    return true;
  }
}
